import type { GoalBannerLevel } from "~/hooks/learning-center/transformers";

/**
 * Port of hec-composable `goal-banner/goalBannerProgressBar.jsx`. A level's
 * module-completion progress bar + `complete/total` count, driven by
 * `createGoalBanner` (`percentComplete`, `completeModulesQty`, `allModulesQty`).
 */
const GoalBannerProgressBar = ({
  levelData,
}: {
  levelData: GoalBannerLevel;
}) => (
  <div
    className="mb-2 mt-2 flex items-center pb-4"
    data-testid="goal-banner-progress"
  >
    <div className="h-2.5 flex-1 rounded-full bg-accent/40">
      <div
        className="h-2.5 rounded-full bg-secondary-foreground"
        style={{ width: `${levelData.percentComplete}%` }}
      />
    </div>
    <span className="ml-2 text-sm text-gray-700">
      {levelData.completeModulesQty}/{levelData.allModulesQty}
    </span>
  </div>
);

export default GoalBannerProgressBar;
